// removed by extract-text-webpack-plugin
module.exports = {"title":"oCcGSmj-qj1y8_FM7HAEK","titleLabel":"_367uRhBdJ2z0OMfgbtS13x","controls":"_1bmVZTrxecuNKg6ZZff4O_","cancelBtn":"bvoe7VUCuIA3nx6GXcUFN","addBtn":"_3dGt4UdOiyeevfi80gO8EX","disabled":"_1tRgYyy06IDeUZCtqcz-un","inputLabel":"_1r8W0F_yrsBwmIBWnMZAMh","inputContainer":"teKW7Ys_D22OkbxjZAlsA","sectionTypeContainer":"_1HiMEW9TQsRdH_K0zSLno"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Groups/GroupList/style/GroupEditor.pcss
// module id = 1372
// module chunks = 0